import { DateTime } from 'luxon';

export function isEditable(effectiveDateEpochMillis: number): boolean {
  const date = DateTime.fromMillis(effectiveDateEpochMillis);
  const startOfMonth = DateTime.now().startOf('month');
  return date >= startOfMonth;
}
